import axios from 'axios'
import { SearchUrlParamBuilder } from '@/core/utils'

class DocumentosApiClient {
	URL_PATH = '/ata-registro-preco/api/public/atas/documentos'

	async buscarDocumentosPorFiltro(filtro, paginacao, idAta) {
		const url = new SearchUrlParamBuilder({
			urlPath: this.URL_PATH + `/${idAta}`,
			filters: filtro,
			pagingAndSorting: paginacao,
		}).buildFiltroPadraoEAvancado()
		return await axios.get(url)
	}

	async baixar(idDocumento) {
		const url = `${this.URL_PATH}/${idDocumento}/baixar`

		return await axios.get(url, {
			responseType: 'arraybuffer',
		})
	}
}

export default new DocumentosApiClient()
